var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoShelf = function SvgIconNoShelf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 449,
    height: 328,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 328,
    fill: "url(#IconNoShelf_svg__a)",
    rx: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 242,
    fill: "url(#IconNoShelf_svg__b)",
    rx: 15,
    transform: "matrix(1 0 0 -1 42 285)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 63,
    x: 151,
    y: 53,
    fill: "url(#IconNoShelf_svg__c)",
    rx: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 63,
    x: 189,
    y: 133,
    fill: "url(#IconNoShelf_svg__d)",
    rx: 15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 63,
    x: 240,
    y: 213,
    fill: "url(#IconNoShelf_svg__e)",
    rx: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconNoShelf_svg__a",
    x1: 98.5,
    x2: 294,
    y1: 41.5,
    y2: 315.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCCCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconNoShelf_svg__b",
    x1: 72.563,
    x2: 216.875,
    y1: 30.619,
    y2: 232.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconNoShelf_svg__c",
    x1: 215.534,
    x2: 231.451,
    y1: 60.971,
    y2: 137.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7EBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconNoShelf_svg__d",
    x1: 253.534,
    x2: 269.451,
    y1: 140.971,
    y2: 217.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7EBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconNoShelf_svg__e",
    x1: 304.534,
    x2: 320.451,
    y1: 220.971,
    y2: 297.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7EBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.89
  })))));
};
export default SvgIconNoShelf;